<template>
  <div v-cloak class="v-cloak--invisible">
    <!-- Header -->
    <section-header
      size="md"
      variants="dividing"
      qaid="sku-grid.bulk-order"
      class="section-header--non-stacking mt-5 xl:mt-0"
    >
      <template slot="content">
        <heading :level="2" size="md">
          {{ bp('bulk') }}
        </heading>
      </template>
      <template slot="actions">
        <div class="flex items-center text-sm font-medium" qaid="sku-grid.unavailable">
          {{ bp('inStock') }}
          <grid-switch class="ml-1" :data="{id: 'show-unavailable'}" @switch-change="hideUnavailable = $event">
          </grid-switch>
        </div>
      </template>
    </section-header>

    <!-- Product Groups wrapper/iterator -->
    <div class="b2b-grid-group">
      <div
        v-for="(productGroup, productGroupIndex) in productGroups"
        :key="productGroupIndex"
        class="b2b-grid-group__section"
        :product-group-index="productGroupIndex"
      >
        <collapse
          icon-active="indeterminate_check_box"
          icon-inactive="add_box"
          icon-position="left"
          align-icon="start"
          :default-active="false"
          :value="viewBreakpointMoreThan('medium') ? [productGroupIndex] : null"
        >
          <bulk-product-grid
            :hide-unavailable="hideUnavailable"
            :base-properties="baseProperties"
            :image-size="{width: 192, height: 144}"
            image-format="pjpeg"
            image-quality="60,1"
            image-unsharp-mask
            :base-product="baseProductCode"
            :product-group="productGroup"
            :product-type="productGroup.productType"
            :product-group-index="productGroupIndex"
            :apple-table-headers="appleTableHeaders"
            :is-pdp="isPdp"
            @update-stock-watch-state="(payload) => $emit('update-stock-watch-state', payload)"
            @update-cart-or-list-column="updateColumns"
          />
        </collapse>
      </div>
    </div>
  </div>
</template>

<script>
import viewSize from '@/mixins/view-size';
import SectionHeader from '@/components/SectionHeader';
import GridSwitch from '@/components/grid/GridSwitch';
import Collapse from '@/components/Collapse';
import BulkProductGrid from '@/components/containers/bulk-product/BulkProductGrid';
import Heading from '@/components/Heading';

export default {
  components: {SectionHeader, GridSwitch, Collapse, BulkProductGrid, Heading},

  mixins: [viewSize],

  props: {
    appleTableHeaders: {
      type: Array,
      default: () => [],
    },
    productGroups: {
      type: Array,
      default: () => [],
    },
    isPdp: Boolean,
  },

  data() {
    return {
      hideUnavailable: false,
    };
  },

  computed: {
    baseProductCode() {
      return !this.productGroups || !('code' in this.productGroups) ? '' : this.productGroups.code;
    },
  },

  methods: {
    updateColumns(responseData) {
      const responseEntries = responseData.response;
      const colName = responseData.colName;
      this.productGroups.forEach((productGroup) => {
        const products = productGroup.products;
        this.$store.dispatch('skuGrid/updateCartOrListColumn', {products, responseEntries, colName}).then((res) => {
          productGroup.products = res;
        });
      });
    },
  },
};
</script>
